import { VOLUME_UOMS, WEIGHT_UOMS } from './packingListConstants';

/**
 * il_pl_item 전 컬럼. compact=true 컬럼만 기본으로 보이고 "Show all columns"로 나머지를 연다.
 * 검수 그리드는 단위를 별도 칸으로 두어 따로 고친다. unitField는 값 칸의 단위 필드로, 확정 아이템 표는 단위 칸을 빼고 값 칸에 "4 PCS"처럼 붙여 보여준다.
 * width는 검수 그리드, mainWidth는 확정 아이템 표의 너비다. 확정 아이템 표에는 단위 칸이 없어 단위 칸에는 mainWidth가 없다.
 * options가 있는 칸은 그 목록에서만 고른다. maxLength는 확정 때 저장되는 칸의 크기다. 넘으면 저장이 실패하므로 입력에서 막는다. Description처럼 크기 제한이 없는 칸에는 두지 않는다.
 */
export const ITEM_COLUMNS = [
    { field: 'line_no', headerName: '#', width: 35, mainWidth: 35, minWidth: 35, type: 'number', compact: true, readOnly: true, align: 'center' },
    { field: 'po_number', headerName: 'PO No.', width: 110, mainWidth: 120, compact: true, mono: true, maxLength: 100 },
    { field: 'item_code', headerName: 'Item Code', width: 110, mainWidth: 120, compact: true, mono: true, maxLength: 100 },
    { field: 'buyer_sku', headerName: 'Buyer SKU', width: 110, mainWidth: 130, mono: true, maxLength: 100 },
    { field: 'barcode', headerName: 'Barcode', width: 120, mainWidth: 120, mono: true, maxLength: 100 },
    { field: 'style_name', headerName: 'Style', width: 90, mainWidth: 90, maxLength: 255 },
    { field: 'description', headerName: 'Description *', width: 240, mainWidth: 260, compact: true, required: true },
    { field: 'description_alt', headerName: 'Local Description', width: 240, compact: true },
    { field: 'country_of_origin', headerName: 'COO', width: 60, mainWidth: 60, maxLength: 100 },
    { field: 'qty', headerName: 'Qty *', width: 70, mainWidth: 70, type: 'number', compact: true, required: true, unitField: 'qty_uom' },
    { field: 'qty_uom', headerName: 'UOM', width: 80, compact: true, editor: 'uom', maxLength: 25 },
    { field: 'net_weight', headerName: 'N.W', width: 90, mainWidth: 80, type: 'number', unitField: 'weight_uom' },
    { field: 'gross_weight', headerName: 'G.W', width: 90, mainWidth: 80, type: 'number', unitField: 'weight_uom' },
    { field: 'weight_uom', headerName: 'W.UOM', width: 80, options: WEIGHT_UOMS, maxLength: 10 },
    { field: 'volume', headerName: 'Volume', width: 80, mainWidth: 80, type: 'number', unitField: 'volume_uom' },
    { field: 'volume_uom', headerName: 'V.UOM', width: 80, options: VOLUME_UOMS, maxLength: 10 },
    { field: 'lot_no', headerName: 'LOT No.', width: 110, mainWidth: 120, editor: 'lot', mono: true, maxLength: 100 },
    { field: 'production_date', headerName: 'Prod. Date', width: 100, mainWidth: 100, editor: 'date' },
    { field: 'expiry_date', headerName: 'Expiry', width: 100, mainWidth: 100, editor: 'date' },
];

/** 헤더 글자 칸의 저장 크기. 넘으면 확정 때 저장이 실패한다. */
export const HEADER_TEXT_LIMITS = [
    { field: 'invoice_no', label: 'PL Invoice No.', maxLength: 100 },
    { field: 'po_number', label: 'Header PO No.', maxLength: 100 },
    { field: 'asn_no', label: 'ASN No.', maxLength: 100 },
    { field: 'country_of_origin', label: 'Country of Origin', maxLength: 100 },
    { field: 'shipper_name', label: 'Shipper', maxLength: 255 },
    { field: 'consignee_name', label: 'Consignee', maxLength: 255 },
];

/** 헤더 칸의 저장 크기. 제한이 없는 칸은 undefined. */
export const headerMaxLength = (field) => HEADER_TEXT_LIMITS.find((l) => l.field === field)?.maxLength;

/** Other Qty 수량 행 단위(uom)의 저장 크기. */
export const QUANTITY_UOM_MAX_LENGTH = 25;

/** 확정 아이템 표에서 처음에 숨겨 두는 컬럼. 나머지는 보이며, 사용자는 Columns 패널에서 켜고 끈다(화면을 다시 열면 이 기본값으로 돌아간다). */
export const MAIN_HIDDEN_COLUMNS = ['buyer_sku', 'barcode', 'style_name', 'lot_no', 'production_date', 'expiry_date'];

/** 확정 아이템 표에만 있는 칸의 너비. */
export const MAIN_EXTRA_WIDTHS = { other_quantities: 140 };

/** 값 칸에 붙여 보여주는 단위 칸. 확정 아이템 표에서는 따로 두지 않는다. */
export const UNIT_FIELDS = new Set(ITEM_COLUMNS.map((c) => c.unitField).filter(Boolean));

/** 값과 단위를 한 칸에 붙여 쓴다. 값이 없으면 빈 문자열이다. */
export const withUnit = (value, unit) => {
    if (value === null || value === undefined || value === '') return '';
    const n = Number(value);
    const text = Number.isFinite(n) ? n.toLocaleString(undefined, { maximumFractionDigits: 6 }) : String(value);
    return unit ? `${text} ${unit}` : text;
};
